// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__W7shg","Content":"Badge_Content__U7U0h","Title":"Badge_Title__-Dz73","SecondLine":"Badge_SecondLine__PBSJr"};